var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"content"},[(_vm.dismissable)?_c('a',{on:{"click":_vm.dismiss}},[_vm._v(" Close ")]):_vm._e(),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }